/**
 * HTML DIV elements builder.
 *
 * @author Stanislav Kalashnik <darkpark.main@gmail.com>
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

/**
 * Create a new HTML DIV element.
 *
 * @param {string|null} [className] - element class name/names
 * @param {...*} [content] - element content (primitive value/values or other nodes)
 *
 * @return {Node|null} HTML element or null on failure
 *
 * @example
 * div();
 * div('className', 'some text');
 * div('className anotherClassName', div(), div());
 */
module.exports = function ( className ) {
    var node = document.createElement('div'),
        index;

    if ( className ) {
        node.className = className;
    }

    // content (arguments except the first)
    for ( index = 1; index < arguments.length; index += 1 ) {
        // some data is given
        if ( arguments[index] ) {
            // regular HTML tag or plain data
            node.appendChild(
                typeof arguments[index] === 'object' ? arguments[index] : document.createTextNode(arguments[index])
            );
        }
    }

    return node;
};
